import { createContext } from 'solid-js'

/**
 * Shop-wide follow-up to every committed purchase made through the Shop
 * purchase flow (GLOSSARY.md: Shop purchase flow) — a tree or land-skin
 * unlock, a free unlock, a coin exchange, a Time Crystal IAP, and any later
 * product the flow carries. The app provides it once (the starter-pack
 * refetch, GLOSSARY.md "Starter pack (新手禮包)"); every flow's commit reaches
 * it without threading a prop through each surface. The Daily Picks refresh
 * runs its own flow and never reaches it.
 */
export const PurchaseCommittedContext = createContext<
  (productId: number) => void
>(() => {})
